export function formatQuestions(content: string): string {
  const lines = content.split('\n');
  const question = lines[0];
  
  const options = lines
    .slice(1)
    .filter(line => line.includes('-'))
    .map(line => line.trim());
    
  return `${question}\n\n${options.join('\n')}`;
}